module.exports = "/images/vendor/flag-icon-css/flags/1x1/ae.svg?7847726d0663899a3e31b3e21b6d2b68";